// ANCHOR React
import React, { memo, useEffect } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';

// ANCHOR Graph State
import { useSignInErrorDispatch } from '@lyon/nodes/global/sign-in-error-node';
import { useSignInVisibilityShow } from '@lyon/nodes/global/sign-in-visibility-node';

// ANCHOR Model
import { RestrictedInfo } from '@lyon/scoped-models/RestrictedInfo';

// ANCHOR Components
import { LyonRestrictedImageContainer } from './LyonRestrictedImageContainer';
import { LyonRestrictedInfo } from './LyonRestrictedInfo';

// ANCHOR Styles
import { BLOCK } from './styles';

// ANCHOR Constants
import { ERROR } from './constants';

interface IProps {
  title: string;
  description: string;
  auth?: boolean;
  actionButton?: React.ReactNode;
}

export const LyonRestricted = memo(({
  title, description, auth, actionButton,
}: IProps) => {
  const show = useSignInVisibilityShow();
  const setError = useSignInErrorDispatch();

  useEffect(() => {
    if (auth) {
      setError(ERROR);
      show();
    }
  }, [setError, show, auth]);

  return (
    <Block overrides={BLOCK}>
      <RestrictedInfo.Provider title={title} description={description}>
        <LyonRestrictedImageContainer />
        <LyonRestrictedInfo auth={auth} actionButton={actionButton} />
      </RestrictedInfo.Provider>
    </Block>
  );
});
